<!--  -->
<template>
  <div>
    <div>
      广告主id： <el-input
        v-model="query.account_id"
        style="width: 200px"
      />
      广告id： <el-input
        v-model="query.adgroup_id"
        style="width: 200px"
      />
      <!-- 类型： <el-select
        v-model="query.batch_type"
        placeholder="请选择"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select> -->
      状态：<el-select v-model="query.status">
        <el-option
          v-for="item in options2"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button
        type="primary"
        style="margin-left: 10px"
        @click="search"
      >查询</el-button>
    </div>
    <el-table
      :data="tableData"
      style="margin-top: 10px"
      border
    >
      <el-table-column
        prop="id"
        label="id"
        width="80px"
        align="center"
      />
      <el-table-column
        prop="account_id"
        label="广告主id"
        width="120px"
        align="center"
      />
      <el-table-column
        prop="adgroup_id"
        label="广告id"
        width="120px"
        align="center"
      />
      <el-table-column
        prop="status_text"
        label="状态"
        width="120px"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status == 1"
            type="success"
          >成功</el-tag>
          <el-tag
            v-else
            type="danger"
          >失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="batch_type_text"
        label="类型"
        align="center"
        width="120px"
      />
      <el-table-column
        prop="created_at"
        label="创建时间"
        align="center"
        width="130px"
      />
      <el-table-column
        prop="fail_reason"
        label="失败原因"
        align="center"
      />
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { updAdLognew } from '@/api/report/accountManagement'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: { PaginationRight },
  data() {
    return {
      options: [
        { value: 'del_ads', label: '删除广告' },
        { value: 'remove_area', label: '移除区域' },
        { value: 'exclude_custom', label: '排除人群包' },
        { value: 'bid', label: '出价/ROI' },
        { value: 'stop_copy_ad', label: '暂停广告' },
        { value: 'feedback', label: '监测链接' }
      ],
      options2: [
        { value: '1', label: '成功' },
        { value: '2', label: '失败' },
        { value: '0', label: '全部' }
      ],
      query: {
        status: '0',
        page: 1,
        page_size: 10,
        account_id: null,
        adgroup_id: null,
        batch_type: 'exclude_custom'
      },
      tableData: null,
      total: 0
    }
  },
  created() {
    this.adLogList()
  },
  mounted() {},
  methods: {
    adLogList() {
      updAdLognew(this.query).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    search() {
      this.adLogList()
    },
    fetchPageSize(val) {
      this.query.page_size = val
      this.adLogList()
    },
    fetchCurrentPage(val) {
      this.query.page = val
      this.adLogList()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sizew_text {
  color: rgb(169, 162, 151);
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.sadrw {
  width: 70px;
  text-align: right;
}
.text_serw {
  width: 200px;
}
</style>
